/**
 * Created by hernanherreros on 2019-05-06
 */
import { defaultSteps, formRouterConfig, RouterItem } from '../config/router.config'
import { customRoutes, customSteps } from '../modules'

const emptyRoute = {
  path: '',
  slug: '',
  label: '',
  component: null,
  number: 1,
}

export const getRouteConfig = (congressSlug: string, slug?: string): RouterItem => {
  if (!slug) {
    return emptyRoute
  }

  if (customRoutes.hasOwnProperty(congressSlug)) {
    const customRoute = customRoutes[congressSlug].find((item: RouterItem) => item.slug === slug)

    if (customRoute) {
      return customRoute
    }
  }

  const defaultRoute = formRouterConfig.find((item: RouterItem) => item.slug === slug)

  if (defaultRoute) {
    return defaultRoute
  }

  return emptyRoute
}

export const getSteps = (congressSlug: string): string[] => {
  if (customSteps.hasOwnProperty(congressSlug)) {
    const customStep = customSteps[congressSlug]

    if (customStep) {
      return customStep
    }
  }

  return defaultSteps
}

